import config from "./config.js";

export default async function GetReCaptchaToken()
{
    let wait_count = 0;
    while (window.grecaptcha === undefined)
    {
        await Delay(100);
        wait_count++;

        if (wait_count >= 50)
        {
            throw new Error("Timed out waiting on reCAPTCHA to load.");
        }
    }

    return await new Promise((resolve, reject) => {
        try
        {
            window.grecaptcha.ready(async function() {
                let token = await window.grecaptcha.execute(config.recaptcha_site_key, {action: 'submit'});
                resolve(token);
            });
        }
        catch (ex)
        {
            reject(ex);
        }
    });
}

function Delay(ms)
{
    return new Promise(resolve => setTimeout(resolve, ms));
}